import React from 'react';
import Draggable from 'react-draggable';

import { PaperProps } from '@mui/material';
import { Paper } from './Paper';

export const DraggablePaper: React.FunctionComponent<PaperProps> = function (props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel='[class*="MuiDialogContent-root"]'
        >
            <Paper {...props} />
        </Draggable>
    );
};
